const mutations = {
  reset_states () {},
  setCategories(state, categories) {
    state.categories = categories
  },
  setTopCategories(state, categories) {
    state.topCategories = categories
  },
  globalLoading(state, isLoading) {
    state.isAppLoading = isLoading
  },
  setQuickViewProduct(state, payload) {
    state.quickViewProduct = payload
  }
}

export default mutations
